import { Component, OnInit, Inject, OnDestroy, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { PaymentModalReturn } from '../../../../models/payment-modal-return';
import { environment } from '../../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-paymenttech-form-popup',
  templateUrl: './paymenttech-form-popup.component.html',
  styleUrls: ['./paymenttech-form-popup.component.css']
})
export class PaymenttechFormPopupComponent implements OnInit, OnDestroy {

  constructor(public dialogRef: MatDialogRef<PaymenttechFormPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: string,
  private sanitizer: DomSanitizer, private ngZone: NgZone, private translateService: TranslateService) { }

  iFrameUrl: SafeUrl;

  ngOnInit() {
    const url = environment.paymentTechFormUrl + '?uID=' + this.data;
    this.iFrameUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    //make a function that call the right function with the right "this"
    window['paymentPopup'] = this;
    window['hpfReady'] = function () {
      window['paymentPopup'].hpfReady();
    };
    window['startPayment'] = function () {
      window['paymentPopup'].startPayment();
    };
    window['cancelPayment'] = function() {
      window['paymentPopup'].cancelPayment();
    };
    window['completePayment'] = function (data) {
      window['paymentPopup'].completePayment(data);
    };
    window['handlePaymentErrors'] = function (data) {
      window['paymentPopup'].handlePaymentErrors(data);
    };
    window['scrollRelay'] = function (scrollX, scrollY) {
      window['paymentPopup'].scrollRelay(scrollX, scrollY);
    };
  }

  ngOnDestroy() {
    delete window['paymentPopup'];
    delete window['hpfReady'];
    delete window['startPayment'];
    delete window['cancelPayment'];
    delete window['completePayment'];
    delete window['handlePaymentErrors'];
    delete window['scrollRelay'];
  }

  //popup controls
  onCloseComplete(uId: string) {
    this.ngZone.run(() => {
      this.dialogRef.close(new PaymentModalReturn('complete', uId));
    });
  }

  onCloseCancel() {
    this.ngZone.run(() => {
      this.dialogRef.close(new PaymentModalReturn('cancel', ''));
    });
  }

  onCloseError(error) {
    console.log(error);
    let errorMessage = '';

    if (error.errorCode) {
      error.errorCode.forEach(element => {
        if (element === '310') {
          errorMessage += this.translateService.instant('PaymentForm.PaymentTech.Errors.MissingCardNumber') + ' \n';
        } else if (element === '370') {
          errorMessage += this.translateService.instant('PaymentForm.PaymentTech.Errors.InvalidExpirationDate') + ' \n';
        } else if (element === '530') {
          errorMessage += this.translateService.instant('PaymentForm.PaymentTech.Errors.RequiredPostalCode') + ' \n';
        } else if (element === '360') {
          errorMessage += this.translateService.instant('PaymentForm.PaymentTech.Errors.RefusedPayment') + ' \n';
        }
      });
    }

    this.ngZone.run(() => {
      this.dialogRef.close(new PaymentModalReturn('error', errorMessage));
    });
  }

  //postMessage
  hpfReady() {
    console.log('HPF Form finished loading.');
  }

  startPayment() {
    console.log('Payment processing start.');
  }

  cancelPayment() {
    console.log('Payment has been canceled by user');
    this.onCloseCancel();
  }

  completePayment(data) {
    console.log('Payment has completed');
    this.onCloseComplete(data.uID);
  }

  handlePaymentErrors(data) {
    console.log('postMessage function handlePaymentErrors is called. \nError: ' + Object.values(data));
    this.onCloseError(data);
  }

  scrollRelay(scrollX, scrollY) {
    console.log('Scroll X: ' + scrollX + '\nScroll Y: ' + scrollY);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/paymenttech-form/paymenttech-form-popup/paymenttech-form-popup.component.ts